import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';

import OneToOneTutorRatesSection from './OneToOneTutorRatesSection';
import GroupTutorRatesSection from './GroupTutorRatesSection';
import { useAppSelector } from '../../../../hooks';
import { getUsersState } from '../../../../store/UserSlice';
import {
  getUserOneToOneTutorRatesAsAdmin,
  resetAdminUserOneToOneTutorRates,
} from '../../../../store/V2/OneToOneTutorRatesSlice';
import {
  getUserGroupTutorRatesAsAdmin,
  resetAdminUserGroupTutorRates,
} from '../../../../store/V2/GroupTutorRatesSlice';
import BasicLoader from '../../../../components/Loaders/BasicLoader';

const TutorRates: FunctionComponent = () => {
  const dispatch = useDispatch();

  // Store
  const usersState = useAppSelector(getUsersState);

  // State
  const [initialLoading, setInitialLoading] = useState(true);

  const userData = usersState.user;

  useEffect(() => {
    initPage();

    return () => {
      dispatch(resetAdminUserOneToOneTutorRates());
      dispatch(resetAdminUserGroupTutorRates());
    };
  }, []);

  const initPage = async () => {
    if (userData) {
      await dispatch(
        getUserOneToOneTutorRatesAsAdmin({
          userId: userData._id,
        })
      );

      await dispatch(
        getUserGroupTutorRatesAsAdmin({
          userId: userData._id,
        })
      );
    }

    setInitialLoading(false);
  };

  if (initialLoading) {
    return (
      <Box sx={{ p: '30px' }}>
        <BasicLoader />
      </Box>
    );
  }

  return (
    <Box>
      <OneToOneTutorRatesSection />

      <div style={{ minHeight: '30px' }} />

      <GroupTutorRatesSection />
    </Box>
  );
};

export default TutorRates;
